import ManualEvaluationDialog from "../ManualEvaluationDialog";
import type {ComponentProps} from "react";

type ControlResultViewDialogProps = Pick<
    ComponentProps<typeof ManualEvaluationDialog>,
    | 'visible'
    | 'onHide'
    | 'callId'
    | 'audioControlId'
    | 'sessionId'
    | 'callStatus'
    | 'transcription'
    | 'validAudioUrl'
    | 'audioUrl'
    | 'audioUrlLoading'
    | 'hasPlayerVisiblePermission'
    | 'onLoadAudio'
    | 'handleResetPlayer'
>;

const ControlResultViewDialog = ({
    visible,
    onHide,
    callId,
    audioControlId,
    sessionId = null,
    callStatus = null,
    transcription,
    validAudioUrl = [],
    audioUrl = null,
    audioUrlLoading = false,
    hasPlayerVisiblePermission = false,
    onLoadAudio,
    handleResetPlayer,
}: ControlResultViewDialogProps) => (
    <ManualEvaluationDialog
        visible={visible}
        onHide={onHide}
        callId={callId}
        audioControlId={audioControlId}
        sessionId={sessionId}
        callStatus={callStatus}
        transcription={transcription}
        validAudioUrl={validAudioUrl}
        audioUrl={audioUrl}
        audioUrlLoading={audioUrlLoading}
        hasPlayerVisiblePermission={hasPlayerVisiblePermission}
        onLoadAudio={onLoadAudio}
        handleResetPlayer={handleResetPlayer}
        variant="controlResultView"
    />
);

export default ControlResultViewDialog;
